import React, { useState } from 'react';
import { View } from "react-native"
import { useDispatch, useSelector } from 'react-redux';
import { BestAvailableOrderProps, EventOrderStatProps, TradeProps } from '../store/types/mk_svc';
import { BEEventApi, MarketComponents } from 'be-components';
import { V1_LOAD_EXTERNAL_PRICE_COMPARISON } from '../store/actionsv1/types';
import { market_getLatestTradesByEventId, market_setDraftOrder } from '../store/actionsv1/markets';
import { PlayerPremiumItem } from '../store/types/auth_svc';
import { event_activateEvent } from '../store/actionsv1/events';
import moment from 'moment';
import { util_updateShare } from '../store/actionsv1/utils';

type TeamEventHolderProps = {
    event_id:string,
    expanded?:boolean,
    navigation:any
}
const TeamEventHolder = ({ event_id, navigation, expanded }:TeamEventHolderProps) => {
    const [ activate_loading, setActivateLoading ] = useState(false);
    const dispatch = useDispatch();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const event = useSelector((state:any) => state.event.events[event_id], (left, right) => left == right);
    const latest_trades:TradeProps[] = useSelector((state:any) => state.market.latest_trades[`team:${event_id}`], (left, right) => left == right);
    const best_available:BestAvailableOrderProps[] = useSelector((state:any) => state.market.best_available[`team:${event_id}`], (left, right) => left == right)
    const order_stats:EventOrderStatProps[] = useSelector((state:any) => state.market.order_stats[`team:${event_id}`], (left, right) => left == right);
    const premium_grades = useSelector((state:any) => state.player.player_premium_items_list.player_premium_items.find((ppi:PlayerPremiumItem) => ppi.premium_item?.identifier == 'order_grades'), (left, right) => left?.last_update_datetime == right?.last_update_datetime);
    const markets = useSelector((state:any) => state.market.markets, (left,right) => left == right);
    const league = useSelector((state:any) => state.event.leagues.find(l => l.league_id == event?.league_id), (left, right) => left?.league_id == right?.league_id);
    //Get Comps and squares
    const squares_competitions_list = useSelector((state:any) => state.comp.squares_competitions_list, (left, right) => left.updated == right.updated);
    const squares_competitions = squares_competitions_list.squares_competitions.filter(sc => sc.event_id == event_id);

    const competitions_list = useSelector((state:any) => state.comp.stored_competitions, (left, right) => left.updated == right.updated);
    const competitions = competitions_list.competitions.filter(sc => sc.linked_event_ids && sc.linked_event_ids.includes(event_id) && moment().isBefore(moment(sc.scheduled_datetime)));
    const handleActivateEvent = async() => {
        setActivateLoading(true);
        await dispatch(event_activateEvent(event_id))
        setTimeout(() => {
            handleRefreshTrades()
        }, 3000);
    }

    const handleRefreshTrades = async() => {
        await dispatch(market_getLatestTradesByEventId(event_id, 'team'))
        setActivateLoading(false)
    }

    if(!event){ return <></> }

    let show_grades = false
    if(player?.type == 'premium' || premium_grades){ show_grades = true }

    return (
        <MarketComponents.TeamEventMarket
        event={{ ...event, over:{abbr:'Over'}, under:{abbr:'Under'}, yes:{abbr:'Yes'}, no:{abbr:'No'}, heads:{abbr:'Heads'}, tails:{abbr:'Tails'} }}
        league={league}
            onShare={(e) => {
                dispatch(util_updateShare({
                    share_key: `${e.event_id}_share`,
                    visible:true,
                    title: `BettorEdge Markets - ${e.event_title}`,
                    type_id: e.event_id,
                    link_type: 'user_generated_link',
                    link_sub_type: 'team_contest_link',
                    redirect_url: `https://app.bettoredge.com/markets/market/team/${e.event_id}/2`,
                    embed : {
                        embed_code: `
                            <div id='market' style={{ height: '300px' }} data-teamids='' data-eventids='${e.event_id}' />
                            <script src='https://widgets.bettoredge.com/widget.common.js'> </script>\n
                            <script src='https://widgets.bettoredge.com/widget.market.js'> </script>
                            `
                            ,
                        widget_element: <div style={{ height: '300px' }} id='market' data-teamids='' data-eventids={e.event_id}/>,
                        script_source:'https://widgets.bettoredge.com/widget.market.js',
                        div_id:'market'
                    }
                }))
            }}
            show_podcasts
            onPodcastSelect={(pod) => navigation.navigate('SocialStack', { screen:'PodcastEpisodes', initial:false, params: { podcast_id: pod.podcast_id } })}
            default_price_view='best_available'
            markets={markets}
            init_expanded={expanded}
            show_id={player?.role == 'admin' ? 'true' : undefined}
            show_grades={show_grades}
            squares_competitions={squares_competitions}
            competitions={competitions}
            onEvent={(be_event) => BEEventApi.saveEvent(be_event)}
            activate_loading={activate_loading}
            onActivate={player?.role == 'admin' ? () => handleActivateEvent() :undefined}
            onTradeLongPress={(trade:TradeProps) => {
                dispatch({ 
                    type: V1_LOAD_EXTERNAL_PRICE_COMPARISON, 
                    external_price_comparison: {
                        event_id:trade.event_id,
                        event_type:trade.event_type,
                        init_market:trade.market,
                        side: trade.side,
                        participant_id: trade.market?.level == 'event' ? undefined : trade.side_id,
                        participant_type: trade.market?.level == 'event' ? undefined : trade.side_type
                    }  
                }) 
            }}
            onTeamSelect={(team_id) => navigation.push('Team', { team_id })}
            onViewAdditionalMarkets={(event_id) => navigation.push('AdditionalMarkets', { event_id: event_id })}
            onView={(d) => navigation.push('Market', { event_id:d.event_id, event_type: d.event_type, market_id: d.market_id, participant_type:d.side_type, participant_id:d.side_id })}
            onCompetitionSelect={(competition_id) => navigation.navigate('CompetitionStack', { screen: 'CompetitionPlay', initial:false, params: { competition_id } })}
            onSquaresSelect={(sq_comp_id) => navigation.navigate(`CompetitionStack`, { screen: 'SquaresPlay', initial:false, params:{ sq_comp_id } })}
            best_available_orders={best_available ?? []}
            event_order_stats={order_stats ?? []}
            latest_trades={latest_trades ?? []}
            onOrder={(order) => dispatch(market_setDraftOrder(order))}
        />
    )
}

export default React.memo(TeamEventHolder, (left, right) => {
    if(left.event_id != right.event_id){ return false }
    if(left.expanded != right.expanded){ return false }
    return true
})